"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var baseDealerLayoutStyles_1 = require("./baseDealerLayoutStyles");
var BaseDealerLayout = function (_a) {
    var mainContentSlot = _a.mainContentSlot, disclaimerSlot = _a.disclaimerSlot, pageTitleSlot = _a.pageTitleSlot, pageInfoSlot = _a.pageInfoSlot;
    var styles = baseDealerLayoutStyles_1.default();
    return (<>
      <core_1.Grid container={true} classes={{ container: styles.layoutContainer }}>
        <core_1.Grid item={true} xs={12}>
          {pageInfoSlot}
        </core_1.Grid>
        <core_1.Grid item={true} xs={12}>
          {pageTitleSlot}
        </core_1.Grid>
        <core_1.Grid item={true} xs={12}>
          {mainContentSlot}
        </core_1.Grid>
      </core_1.Grid>
      {disclaimerSlot}
    </>);
};
exports.default = BaseDealerLayout;
